import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const acceptAgreement = (version: number): Promise<void> => HttpClient.post(API_FACTORY.v1(`users/eula/${version}/sign`));
